import React, { useMemo } from 'react'
import { Image, Path, Svg, Text, View } from '@react-pdf/renderer'

// evertel
import { Api } from '@evertel/api'
import { useService } from '@evertel/di'
import { APIDataMediaToNormalizedMedia } from '@evertel/media'
import { useDocumentService } from '@evertel/service'
import { formatBytes, sortMediaByType } from '@evertel/utils'
import Wrapper from './Wrapper'
import { APIDataMedia } from '@evertel/types'


export interface MediaReadWidgetProps {
    id: number|string
    value: number[]
    title: string
    description: string
}

const MediaReadWidget: React.FC<MediaReadWidgetProps> = ({
    value,
    title,
    description
}) => {

    const api = useService(Api)
    const meta = useDocumentService<{ media: APIDataMedia[] }>('meta')

    const mediaIds = useMemo(() => {
        if (!value) return []

        // old bad-data case
        // @ts-expect-error historical issue
        const uploaded = value?.uploaded
        const raw = uploaded ?? value

        return Array.isArray(raw) ? raw : [raw]
    }, [value])

    const foundMedia = meta.media?.filter((m) => mediaIds?.find((v) => v === m.id)) || []
    const mediaSorted = sortMediaByType(foundMedia.map(m => APIDataMediaToNormalizedMedia(m)))

    const nonImageMedia = mediaSorted.filter(m => !['image'].includes(m.mediaType))
    const imageMedia = mediaSorted.filter(m => ['image'].includes(m.mediaType))

    return (
        <Wrapper
            title={title}
            description={description}
        >
            {nonImageMedia.length > 0 && (
                <View style={{ marginBottom: 10 }}>
                    <View style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        gap: 8
                    }}>
                        {nonImageMedia.map((file) => (
                            <View key={file.id} style={{
                                backgroundColor: '#f3f4f6',
                                borderRadius: 4,
                                padding: 6,
                                marginBottom: 4,
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'flex-start',
                                minWidth: 150  // Ensure minimum width to prevent too narrow boxes
                            }}>
                                <View style={{
                                    width: 16,
                                    height: 16,
                                    marginRight: 4,
                                    marginTop: 2  // Align icon with text better
                                }}>
                                    <Svg viewBox="3 1 19 22" style={{ width: 16, height: 16 }}>
                                        <Path
                                            d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
                                            fill="none"
                                            stroke="#666"
                                            strokeWidth={2}
                                        />
                                        <Path
                                            d="M14 2V8H20"
                                            fill="none"
                                            stroke="#666"
                                            strokeWidth={2}
                                        />
                                    </Svg>
                                </View>
                                <View style={{ flex: 1 }}>
                                    <Text style={{
                                        fontSize: 12
                                    }}>{file.fileName}</Text>
                                    <Text style={{ fontSize: 8 }}>{formatBytes(file.contentLength, 1)}</Text>
                                </View>
                            </View>
                        ))}
                    </View>
                </View>
            )}

            {imageMedia.length > 0 && (
                <View style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between'
                }}>
                    {imageMedia.map((image) => (
                        <View wrap={false} key={image.id} style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginBottom: 10
                        }}>
                            <Text style={{
                                fontSize: 8,
                                marginBottom: 4,
                                textAlign: 'center'
                            }}>
                                {image.fileName}
                            </Text>
                            <Image
                                src={{
                                    // uri: 'http://localhost:4200/assets/img/BLUE-logo.png',
                                    // uri: 'http://localhost:4200/assets/img/sampleposts/dark-grey-impala.jpg',
                                    uri: image.url,
                                    method: 'GET',
                                    headers: {Authorization: api.authToken},
                                    credentials: 'omit'
                                }}
                                style={{
                                    width: '28vw',
                                    height: '30vw',
                                    objectFit: 'contain'
                                }}
                            />
                        </View>
                    ))}
                </View>
            )}
        </Wrapper>
    )
}

MediaReadWidget.displayName = 'MediaReadWidget (PDF)'

export { MediaReadWidget }
